/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ShipmentVoModel } from './shipment-vo.model';

export class ShipmentGroupSolutionSegmentVoModel extends JSONable {

  uuid: string | undefined = undefined;

  previousSegmentUuid: string | undefined = undefined;

  isisFirstSegmentInSolution: boolean | undefined = undefined;

  shipmentDraftDTOs: ShipmentVoModel[] | undefined = undefined;

  sourceName: string | undefined = undefined;

  sourceCity: string | undefined = undefined;

  sourceCountry: string | undefined = undefined;

  destName: string | undefined = undefined;

  destCity: string | undefined = undefined;

  destCountry: string | undefined = undefined;
}
